/**
 * Session and stage lifecycle — ARCHITECTURE.md §2, §3, §16, §17, §25.
 */
/** §2 — browser fallback never gets the same assurance as native capture. */
export const ASSURANCE_LEVELS = ['NATIVE_HIGH', 'WEB_LOW_ASSURANCE'];
export const SESSION_STATUSES = [
    /** Created by business backend; link not yet opened. */
    'created',
    /** Claimed by a capture client; capture in progress. */
    'active',
    /** All stages uploaded; verification pipeline running. */
    'processing',
    /** Pipeline done; waiting on manual review. */
    'in_review',
    'approved',
    'rejected',
    'expired',
    'cancelled',
];
export const STAGE_STATUSES = [
    /** Not started. */
    'pending',
    /** Upload initiated for current attempt. */
    'uploading',
    /** Upload completed + hash verified; queued for validation. */
    'uploaded',
    /** Verification job running. */
    'validating',
    /** Server-side acceptance passed — §16/§17 acceptance lists. */
    'accepted',
    /** Server-side acceptance failed; client must retake (new attempt). */
    'rejected',
    /** Client-reported invalidation (backgrounded, interruption, orientation…) — §25. */
    'invalidated',
];
export const DEFAULT_DOCUMENT_PROFILE = {
    profileId: 'generic-driving-licence-v1',
    displayName: 'Driving Licence',
    expectedBarcode: 'NONE',
    frontHasPortrait: true,
};
/** Stage invalidation reasons the client may report — §11, §25. */
export const STAGE_INVALIDATION_REASONS = [
    'app_backgrounded',
    'orientation_changed',
    'camera_interrupted',
    'lens_switched',
    'sustained_blur',
    'card_lost',
    'face_lost',
    'severe_glare',
    'fps_below_threshold',
    'local_quality_failed',
    'user_retake',
    'hard_timeout',
];
//# sourceMappingURL=session.js.map